import { render, staticRenderFns } from "./TestAreas.vue?vue&type=template&id=005a0762"
import script from "./TestAreas.vue?vue&type=script&lang=js"
export * from "./TestAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports